import { Input } from "@/components/ui/input";
import { statusStyle } from "@/lib/api";

const Label = ({ children }) => <span className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1">{children}</span>;

export const TextField = ({ label, value, onChange, testId, type = "text", list, ...rest }) => (
  <label className="block">
    <Label>{label}</Label>
    <Input
      data-testid={testId}
      type={type}
      list={list}
      value={value ?? ""}
      onChange={(e) => onChange(type === "number" ? Number(e.target.value) : e.target.value)}
      className="h-9 text-sm bg-white"
      {...rest}
    />
  </label>
);

export const DateField = ({ label, value, onChange, testId }) => (
  <TextField label={label} type="date" value={value ? value.slice(0, 10) : ""} onChange={(v) => onChange(v || null)} testId={testId} />
);

export const SelectField = ({ label, value, onChange, options, testId, placeholder = "—", plain }) => {
  const opts = value && !options.includes(value) ? [value, ...options] : options;
  return (
    <label className="block">
      <Label>{label}</Label>
      <select data-testid={testId} className="field-select font-medium" style={(!plain && statusStyle(value)) || undefined} value={value || ""} onChange={(e) => onChange(e.target.value)}>
        <option value="">{placeholder}</option>
        {opts.map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
    </label>
  );
};

export const DataList = ({ id, options }) => (
  <datalist id={id}>
    {options.map((o) => <option key={o} value={o} />)}
  </datalist>
);

export const Section = ({ title, children, testId, action }) => (
  <section data-testid={testId} className="bg-white border border-slate-200 rounded-lg p-5 fade-up">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-600">{title}</h3>
      {action}
    </div>
    {children}
  </section>
);
